import { render, staticRenderFns } from "./PlayerWinStreaks.vue?vue&type=template&id=2560312f&"
import script from "./PlayerWinStreaks.vue?vue&type=script&lang=js&"
export * from "./PlayerWinStreaks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports